module.exports = __webpack_public_path__ + "img/rb-care-logo-no-bg.5156fcc6.png";